export default __webpack_public_path__ + "static/media/person.182aa0ea.png";